<div *ngIf="permission">
  <div class="header_search">
    <div class="title-page">
      <h3>Execução Orçamentária</h3>
    </div>
  </div>

  <div class="system-table table-container system-table-m-b">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th>Ano</th>
            <th class="text-center btn-icon-td">Ações</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of execucao; let i = index">
            <tr [ngClass]="{'active': item?.budget_active}">
              <td class="title">{{ item?.ano_exercicio }}</td>
              <td>
                <div class="btn-icon">
                  <span class="icon-table" *ngIf="item?.execucao_orcamentaria_atribuicao" (click)="item.budget_active = !(item?.budget_active ?? false) ">
                    <img src="assets/images/svgs/arrows-{{item?.budget_active ? 'close' : 'open'}}.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                  </span>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="execucao?.length == 0" class="border-b-radius">
            <td colspan="6" class="text-center">Nenhuma Execução Orçamentária Vinculada.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <ng-container *ngFor="let item of execucao; let i = index">
    <div *ngIf="item?.budget_active && item.execucao_orcamentaria_atribuicao">
      <div class="info-page">
        <h3>{{ item?.ano_exercicio }}</h3>
      </div>

      <div class="system-table table-container">
        <div class="system-table-conteiner">
          <table>
            <thead>
              <tr>
                <th class="title-scroll">Período</th>
                <th class="text-center">Empenhado Acumulado</th>
                <th class="text-center">Liquidado Acumulado</th>
                <th class="text-center">
                  Pago Acumulado
                  <button matButton="elevated" #tooltip="matTooltip"
                      matTooltip='No sistema FPE, refere-se à soma dos valores dos campos "Pago" e "Pagamento Regularizado"'
                      class="btn-help"
                      matTooltipHideDelay="200"
                      aria-label='No sistema FPE, refere-se à soma dos valores dos campos "Pago" e "Pagamento Regularizado"'
                      >
                    question_mark
                  </button>
                </th>
                <th class="text-center">Liquidado Exercício Anterior</th>
                <th class="text-center">
                  Pago Exercício Anterior
                  <button matButton="elevated" #tooltip="matTooltip"
                      matTooltip='No sistema FPE, refere-se à soma dos valores dos campos "Pago" e "Pagamento Regularizado"'
                      class="btn-help"
                      matTooltipHideDelay="200"
                      aria-label='No sistema FPE, refere-se à soma dos valores dos campos "Pago" e "Pagamento Regularizado"'
                      >
                    question_mark
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let month of months; let i = index">
                <ng-container *ngIf="i > 0">
                  <ng-container *ngIf="monthExecution(i, item) as exec">
                    <ng-container *ngIf="!(exec?.length == 0 && monthExecutionManual(item)?.length > 0)">
                      <td class="text-center">{{ month }}</td>
                      <td class="text-center">{{(exec.empenhado ?? 0)| number:'1.2-2'}}</td>
                      <td class="text-center">{{(exec.liquidado ?? 0)| number:'1.2-2'}}</td>
                      <td class="text-center">{{(exec.pago ?? 0)| number:'1.2-2'}}</td>
                      <td class="text-center">{{(exec.liquidado_exercicio_anterior ?? 0)| number:'1.2-2'}}</td>
                      <td class="text-center">{{(exec.pago_exercicio_anterior ?? 0)| number:'1.2-2'}}</td>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </tr>
              <ng-container *ngIf="monthExecutionManual(item) as execManual">
                <tr *ngFor="let manual of execManual">
                  <ng-container>
                    <td class="text-center">{{ '' }}</td>
                    <td class="text-center">{{(manual.empenhado ?? 0)| number:'1.2-2'}}</td>
                    <td class="text-center">{{(manual.liquidado ?? 0)| number:'1.2-2'}}</td>
                    <td class="text-center">{{(manual.pago ?? 0)| number:'1.2-2'}}</td>
                    <td class="text-center">{{(manual.liquidado_exercicio_anterior ?? 0)| number:'1.2-2'}}</td>
                    <td class="text-center">{{(manual.pago_exercicio_anterior ?? 0)| number:'1.2-2'}}</td>
                  </ng-container>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<app-loading [loader]="isLoading"></app-loading>